/*
 * EditUsername Messages
 *
 * This contains all the text for the EditUsername scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.EditUsername";

export default defineMessages(scope, {
  updateUsername: "Update Username",
  cancel: "Cancel",
  save: "Save",
  errMsgRequiredField: "This field is required!",
  validationError: "Must be 5-100 characters and use supported symbols only",
  errMsgUnchangedUsername:
    "Your new username cannot be the same as your old username.",
  duplicateError: "This username is already in use",
  genericValidationError: "Unable to validate username. Please try again.",
});
